<template>
    <DCard padding>
        <DTable
            :items="terminationReasons.data"
            :fields="[
                {key: 'id', label: __('settings.lov_termination_reasons.table.id')},
                {key: 'name_de', label: __('settings.lov_termination_reasons.table.name_de')},
                {key: 'name_en', label: __('settings.lov_termination_reasons.table.name_en')},
                {key: 'is_internal', label: __('settings.lov_termination_reasons.table.is_internal')},
                {key: 'list_order', label: __('settings.lov_termination_reasons.table.list_order')},
                {key: 'actions', label: '', sorter: false}
            ]"
        >
            <template #is_internal="{item}">
                <td>
                    <DTag
                        v-if="item.is_internal === true"
                        :label="__('settings.lov_termination_reasons.table.yes')"
                    />
                    <DTag
                        v-else
                        :label="__('settings.lov_termination_reasons.table.no')"
                    />
                </td>
            </template>
            <template #list_order="{item}">
                <td>
                    {{ item.list_order ?? '' }}
                </td>
            </template>
            <template #actions="{item}">
                <td class="buttons">
                    <DButton
                        :id="`edit_${item.id}`"
                        icon="pencil"
                        mini
                        @click="$inertia.get(editTerminationReason(item.id))"
                    />
                    <DButton
                        v-if="item.canBeDeleted === 1 && item.is_internal === false"
                        :id="`delete_${item.id}`"
                        icon="trash-can-outline"
                        color="danger"
                        mini
                        @click="openModal(item, 'delete')"
                    />
                    <DButton
                        v-if="item.active === true && item.canBeDeleted === 0 && item.is_internal === false"
                        :id="`deactivate_${item.id}`"
                        :label="__('settings.lov_termination_reasons.table.deactivate')"
                        mini
                        @click="openModal(item, 'deactivate')"
                    />
                    <DButton
                        v-if="item.active === false && item.canBeDeleted === 0 && item.is_internal === false"
                        :id="`activate_${item.id}`"
                        :label="__('settings.lov_termination_reasons.table.activate')"
                        mini
                        @click="openModal(item, 'activate')"
                    />
                </td>
            </template>
        </DTable>
        <DPagination
            v-if="terminationReasons.last_page > 1"
            :active-page="terminationReasons.current_page"
            :pages="terminationReasons.last_page"
            align="center"
            @update:activePage="changePage"
        />

        <DFabs>
            <DFab
                id="btn-add"
                icon="plus"
                :label="__('settings.lov_termination_reasons.add_termination_reason')"
                @click="addTerminationReason"
            />
        </DFabs>

        <ConfirmationModal
            v-if="showModal === true"
            :show-modal="showModal === true"
            :title="modalTitle"
            :message="modalMessage"
            :action="modalAction"
            @close="closeModal"
            @confirm="confirmModal"
        />
    </DCard>
</template>

<script>
import App from '~@/App.vue'
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import LovLayout from '~@/Pages/Settings/Lov/LovLayout.vue'
import ConfirmationModal from '~@/Components/Settings/LovTerminationReasons/ConfirmationModal'

export default {
    layout: [App, LovLayout]
}
</script>

<script setup>

defineProps({
    terminationReasons: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const addTerminationReason = () => router.get(route('settings.termination-reasons.create'))

const showModal = ref(false)
const selectedItem = ref(null)
const modalAction = ref(null)
const modalTitle = ref('')
const modalMessage = ref('')

const changePage = (page) => {
    const queryParameters = {}

    if (page > 1) {
        queryParameters.page = page
    }

    router.get(route('settings.termination-reasons.index'), queryParameters)
}

const editTerminationReason = (id) => route('settings.termination-reasons.edit', { termination_reason: id })

function openModal (item, action) {
    showModal.value = true
    selectedItem.value = item
    modalAction.value = action
    if (action === 'delete') {
        modalTitle.value = __('settings.lov_termination_reasons.modals.deletion.title')
        modalMessage.value = __('settings.lov_termination_reasons.modals.deletion.message')
    }

    if (action === 'activate') {
        modalTitle.value = __('settings.lov_termination_reasons.modals.activation.title')
        modalMessage.value = __('settings.lov_termination_reasons.modals.activation.message')
    }

    if (action === 'deactivate') {
        modalTitle.value = __('settings.lov_termination_reasons.modals.deactivation.title')
        modalMessage.value = __('settings.lov_termination_reasons.modals.deactivation.message')
    }
}

function closeModal () {
    showModal.value = false
    selectedItem.value = null
    modalAction.value = null
    modalTitle.value = ''
    modalMessage.value = ''
}

function confirmModal () {
    if (modalAction.value === 'delete') {
        router.delete(route('settings.termination-reasons.destroy', { termination_reason: selectedItem.value.id }))
    }

    if (modalAction.value === 'activate') {
        router.post(route('settings.termination-reasons.activate', { termination_reason: selectedItem.value.id, active: 1 }))
    }

    if (modalAction.value === 'deactivate') {
        router.post(route('settings.termination-reasons.activate', { termination_reason: selectedItem.value.id, active: 0 }))
    }

    showModal.value = false
    selectedItem.value = null
    modalAction.value = null
    modalTitle.value = ''
    modalMessage.value = ''
}

</script>

<style lang="scss" scoped>
.ul-class{
    margin: 0;
    padding-left: 15px;
}
.buttons {
    display: flex;
    grid-gap: 10px;
}
</style>
